namespace e5 {
    export class Slot<T extends any[]> {
        public once: boolean = false;
        public enabled: boolean = true;

        constructor(
            public readonly signal: Signal<T>, 
            public listener: (...args: T) => any, 
            public context: any, 
            public namespace: string) {
        }

        public execute(target: Signal<T>, args: any[]): void {
            this.listener.apply(this.context, args as any);
        }

        public remove(): void {
            this.signal.remove(this.listener, this.context);
        }

        public dispose(): void {
            this.context = null;
            this.namespace = null;
            this.listener = null;
        }
    }
}